import { WordingMultiAstrologyMeditationLove } from '@/types';

export const MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_FI: WordingMultiAstrologyMeditationLove = {
  components_header_media_content: 'Astrologia',
  components_header_media_multi_content_2: 'Meditaatio',
  components_header_media_multi_content_3: 'Rakkaus',
  components_header_text1: 'Oppaat',
  components_header_text2: 'Blogi',
  hero_text: 'Löydä selkeys, tasapaino ja yhteys.',
  hero_button_text: 'Aloita matkasi',
  components_ressources_subheader_text: 'Vinkkejä ja inspiraatiota',
  components_ressources_span_text: 'Se yhdistää henkilökohtaisia ​​astrologisia näkemyksiä, rauhoittavia meditaatioharjoituksia ja harkittua rakkausohjausta tukeakseen itsensä löytämistä, emotionaalista tasapainoa ja syvempää yhteyttä.',
  components_ressources_card_1_title: 'Meditaatiovinkkejä',
  components_ressources_card_1_text: 'Pikaopas parempaan rauhoittumiseen, hengitykseen ja keskittymiseen.',
  components_ressources_card_2_title: 'Rakkauden opastus',
  components_ressources_card_2_text: 'Yksinkertaisia ​​vinkkejä vahvemman yhteyden ja emotionaalisen tasapainon rakentamiseen.',
  components_ressources_link: 'Tutustu lisää',
  components_notes_and_google_title_1: 'Löydä selkeys',
  components_notes_and_google_title_2: 'Sisäinen rauha',
  components_notes_and_google_title_3: 'Sydänyhteys',
  media_content_section_multi_1_subheader_text: 'Podcastimme',
  media_content_section_multi_2_subheader_text: 'Meditaatiomme',
  media_content_section_multi_3_subheader_text: 'Todellista keskustelua kosmisesta romanssista',
  page_media_content_menu_antistress: 'Stressiä lievittävä',
  page_media_content_menu_mindfulness: 'Tietoinen läsnäolo',
  page_media_content_menu_energyboost: 'Energianlisäys',
  page_media_content_menu_mantra: 'Mantra',
  page_media_content_menu_foundations: 'Säätiöt',
  page_media_content_menu_spirituality: 'Hengellisyys',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psykologia',
  page_media_content_menu_trends: 'Trendit',
  page_media_content_menu_compatibility: 'Yhteensopivuus',
  page_media_content_menu_love: 'Rakkaus',
  text2_section_title: 'BLOGI',
  text2_section_subheader_text: 'Artikkelit ja näkemykset',
  text2_section_button_more: 'Lataa lisää',
  components_text1_section_title: 'OPPAAT',
  components_text1_subheader_text: 'Kosminen tieto päivittäiseen tasapainoon',
  components_text1_span_text: 'Sovita itsesi maailmankaikkeuden rytmeihin: tutustu kuratoituun kokoelmaan syvällisiä astrologisia ja meditatiivisia oppaita, jotka on suunniteltu herättämään sisäinen selkeys, syventämään itsetuntemusta ja tukemaan sielullisen, taivaallisen kasvun matkaasi.',
  components_text1_card_1_title: 'Avoinna hiljaisuudelle',
  components_text1_card_1_text: 'Aloita matkasi perustavanlaatuisten meditaatio- ja astrologiaoppaiden avulla – ihanteellinen ratkaisu sisäisen hiljaisuuden, kosmisten mallien ja henkilökohtaisen oivalluksen etsijöille.',
  components_text1_card_3_title: 'Mielen ja kehon yhteys',
  components_text1_card_3_text: 'Paljasta sisäisen maailmasi syvemmät kerrokset. Nämä oppaat menevät pinnan läpi paljastaen merkityksiä, tunteita ja tietoisia malleja, jotka muokkaavat kokemustasi.',
  components_text1_card_2_title: 'Pohdi ja integroi',
  components_text1_card_2_text: 'Tunneblokeista planeettojen sykleihin – nämä oppaat tarjoavat työkaluja pohdintaan, paranemiseen ja muutokseen tietoisten rituaalien ja astrologisen viisauden avulla.',
  components_text1_link: 'Näytä kaikki oppaat',
  components_footer_text: 'Löydä selkeys, tasapainota mielesi ja yhdisty merkitykseen – sinun paikkasi astrologialle, meditaatiolle ja rakkaudelle.',
};